import {
  CSSProperties,
  HTMLAttributeAnchorTarget,
  MouseEventHandler,
  ReactNode,
} from 'react'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Link from '@mui/material/Link'
import styled from '@mui/material/styles/styled'

export interface MoovyLinkCommonProps {
  style?: CSSProperties
  'aria-label'?: string
  bold?: boolean
  href?: string
  children: ReactNode
  onClick?: MouseEventHandler
}

export interface MoovyLinkProps extends MoovyLinkCommonProps {
  target?: HTMLAttributeAnchorTarget
  showArrowForward?: boolean
  showArrowBackward?: boolean
}

export interface MoovyLinkButtonProps extends MoovyLinkCommonProps {
  loading?: boolean
  red?: boolean
  disabled?: boolean
}

const StyledLinkButton = styled(Button)({
  textTransform: 'none',
  padding: 0,
  minWidth: 0,
  '&:hover': {
    backgroundColor: 'transparent', // Disable hover effect
  },
})

const SingleRightPointingAngleQuotationMark = () => <>&rsaquo;</>
const SingleLeftPointingAngleQuotationMark = () => <>&lsaquo;</>

const MoovyLink = ({
  style,
  'aria-label': ariaLabel,
  bold,
  children,
  href,
  target = '_blank',
  onClick,
  showArrowForward,
  showArrowBackward,
}: MoovyLinkProps) => {
  return (
    <Link
      href={href}
      onClick={onClick}
      target={target}
      fontWeight={bold ? 'bold' : 'normal'}
      underline="none"
      style={style}
      aria-label={ariaLabel}
    >
      {showArrowBackward && (
        <>
          <SingleLeftPointingAngleQuotationMark />{' '}
        </>
      )}
      {children}
      {showArrowForward && (
        <>
          {' '}
          <SingleRightPointingAngleQuotationMark />
        </>
      )}
    </Link>
  )
}

const MoovyLinkButton = ({
  style,
  'aria-label': ariaLabel,
  loading,
  red,
  disabled,
  bold,
  onClick,
  children,
  href,
}: MoovyLinkButtonProps) => {
  return (
    <>
      <StyledLinkButton
        aria-label={ariaLabel}
        style={style}
        onClick={(event) => {
          if (onClick) {
            if (disabled || loading) {
              event.preventDefault()
            } else {
              onClick(event)
            }
          }
        }}
        color={red ? 'error' : undefined}
        href={href}
      >
        {(bold && <b>{children}</b>) || children}
      </StyledLinkButton>
      {loading && <CircularProgress size="mini" />}
    </>
  )
}

export default { Link: MoovyLink, LinkButton: MoovyLinkButton }
